export const CREATE_CLIENT = "CREATE_CLIENT";
export const UPDATE_CLIENT = "UPDATE_CLIENT";
export const GET_ALL_CLIENT_UNDER_SYSTEM_ADMIN ="GET_ALL_CLIENT_UNDER_SYSTEM_ADMIN";
export const GET_CLIENT_DETAILS_BY_ID = "GET_CLIENT_DETAILS_BY_ID";
export const GET_CLIENT_DETAILS_BY_TOKEN = "GET_CLIENT_DETAILS_BY_TOKEN";
export const DELETE_CLIENT_DETAILS_BY_ID = "DELETE_CLIENT_DETAILS_BY_ID";
export const UPDATE_CLIENT_ACCESS = "UPDATE_CLIENT_ACCESS";

const SET_CREATE_CLIENT = "SET_CREATE_CLIENT";
const SET_UPDATE_CLIENT = "SET_UPDATE_CLIENT";
const SET_ALL_CLIENT_UNDER_SYSTEM_ADMIN = "SET_ALL_CLIENT_UNDER_SYSTEM_ADMIN";
const SET_CLIENT_DETAILS_BY_ID = "SET_CLIENT_DETAILS_BY_ID";
const SET_DELETE_CLIENT_DETAILS_BY_ID = "SET_DELETE_CLIENT_DETAILS_BY_ID";
const SET_UPDATE_CLIENT_ACCESS = "SET_UPDATE_CLIENT_ACCESS";
const ACTION_LOADER = "ACTION_LOADER";
const CURRENT_CLIENT = "CURRENT_CLIENT"

export const createClient = payload => {
	return {
		type: CREATE_CLIENT,
		payload,
	};
};

export const setCreateClient = payload => {
	return {
		type: SET_CREATE_CLIENT,
		payload,
	};
};

export const updateClient = payload => {
	return {
		type: UPDATE_CLIENT,
		payload,
	};
};

export const setUpdateClient = payload => {
	return {
		type: SET_UPDATE_CLIENT,
		payload,
	};
};

export const getClientDetailsById = payload => {
	return {
		type: GET_CLIENT_DETAILS_BY_ID,
		payload,
	};
};

export const getClientDetailsByToken = () => {
	return {
		type: GET_CLIENT_DETAILS_BY_TOKEN,
	};
};

export const setClientDetailsById = payload => {
	return {
		type: SET_CLIENT_DETAILS_BY_ID,
		payload: payload,
	};
};

export const deleteClientDetailsById = payload => {
	return {
		type: DELETE_CLIENT_DETAILS_BY_ID,
		payload,
	};
};

export const setDeleteClientDetailsById = payload => {
	return {
		type: SET_DELETE_CLIENT_DETAILS_BY_ID,
		payload,
	};
};

export const updateClientAccess = payload => {
	return {
		type: UPDATE_CLIENT_ACCESS,
		payload,
	};
};

export const setUpdateClientAccess = payload => {
	return {
		type: SET_UPDATE_CLIENT_ACCESS,
		payload,
	};
};

export const getAllClientUnderSysAdmin = () => {
	return {
		type: GET_ALL_CLIENT_UNDER_SYSTEM_ADMIN,
	};
};

export const setAllClientUnderSysAdmin = payload => {
	return {
		type: SET_ALL_CLIENT_UNDER_SYSTEM_ADMIN,
		payload,
	};
};

export const setLoaderState = loadingState => ({
	type: ACTION_LOADER,
	loadingState,
});

export const setCurrentClient = payload => ({
	type: CURRENT_CLIENT,
	payload,
})

const initialState = {
	isOrgLoading: "",
	clientDetails: [],
	updatedClientAccess: {},
	updatedClientData: {},
	clientDetail: {},
	createdClientDetail: {},
	currentSelectedClientId: ""
};

export default (state = initialState, action) => {
	switch (action.type) {
		case SET_CREATE_CLIENT:
			return {
				...state,
				createClient: {...action.payload},
				clientDetails: [...state.clientDetails, {...action.payload}]
			};
		case SET_CLIENT_DETAILS_BY_ID:
			return { ...state, clientDetail: {...action.payload.item} };
		case SET_UPDATE_CLIENT_ACCESS:
			return { ...state, updatedClientAccess: {...action.payload} };
		case SET_DELETE_CLIENT_DETAILS_BY_ID:
			return;
		case SET_ALL_CLIENT_UNDER_SYSTEM_ADMIN:
			return { ...state, clientDetails: [...action.payload.items] };
		case SET_UPDATE_CLIENT:
			return {
				...state,
				updatedClientData: {...action.payload},
			};
		case ACTION_LOADER:
			const { loadingState } = action;
			return { ...state, isOrgLoading: loadingState };
		case CURRENT_CLIENT:
			const { payload } = action;
			return { ...state, currentSelectedClientId: payload }
		default:
			return state;
	}
};
